/**
 * 新規 knz ファイルのデフォルト内容。
 * frontmatter（必須の title / author）と、書き始めやすいサンプルブロックを含む。
 *
 * author はリスト形式（`author:` の下に `- userId`）で出力する。
 * 共著の場合は `- 別の userId` を追記するだけで著者を増やせる。
 */
export const buildKnzTemplate = (author: string): string =>
  [
    '---',
    'title: 無題の記事',
    'author:',
    ` - ${author}`,
    '---',
    '',
    '<--- Section --->',
    'title: はじめに',
    'number:1',
    'anchor:section-1',
    'children:',
    ' - intro',
    '<--- !Section --->',
    '',
    '<--- Text --->',
    'id:intro',
    'text:',
    ' - ここに本文を書きます。',
    '<--- !Text --->',
    '',
  ].join('\n');
